function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import Log from '@deephaven/log';
import { requestParentResponse } from '@deephaven/utils';
import { nanoid } from 'nanoid';
import { SESSION_DETAILS_REQUEST } from "./MessageUtils.js";
import NoConsolesError, { isNoConsolesError } from "./NoConsolesError.js";
var log = Log.module('SessionUtils');
/**
 * Create a new session using the default URL
 * @returns A session and config that is ready to use
 */
export function createSessionWrapper(_x, _x2, _x3) {
  return _createSessionWrapper.apply(this, arguments);
}
function _createSessionWrapper() {
  _createSessionWrapper = _asyncToGenerator(function* (dh, connection, details) {
    log.info('Getting console types...');
    var types = yield connection.getConsoleTypes();
    if (types.length === 0) {
      throw new NoConsolesError('No console types available');
    }
    log.info('Available types:', types);
    var type = types[0];
    log.info('Starting session with type', type);
    var session = yield connection.startSession(type);
    var config = {
      type,
      id: nanoid()
    };
    log.info('Console session established', config);
    return {
      session,
      config,
      connection,
      details,
      dh
    };
  });
  return _createSessionWrapper.apply(this, arguments);
}
export function createCoreClient(dh, websocketUrl, options) {
  log.info('createCoreClient', websocketUrl);
  return new dh.CoreClient(websocketUrl, options);
}
function isSessionDetails(obj) {
  return obj != null && typeof obj === 'object';
}
function requestParentSessionDetails() {
  return _requestParentSessionDetails.apply(this, arguments);
}
function _requestParentSessionDetails() {
  _requestParentSessionDetails = _asyncToGenerator(function* () {
    var response = yield requestParentResponse(SESSION_DETAILS_REQUEST);
    if (!isSessionDetails(response)) {
      throw new Error("Unexpected session details response: ".concat(response));
    }
    return response;
  });
  return _requestParentSessionDetails.apply(this, arguments);
}
export function getSessionDetails() {
  return _getSessionDetails.apply(this, arguments);
}
function _getSessionDetails() {
  _getSessionDetails = _asyncToGenerator(function* () {
    var searchParams = new URLSearchParams(window.location.search);
    switch (searchParams.get('authProvider')) {
      case 'parent':
        return requestParentSessionDetails();
    }
    return {};
  });
  return _getSessionDetails.apply(this, arguments);
}
export function loadSessionWrapper(_x4, _x5, _x6) {
  return _loadSessionWrapper.apply(this, arguments);
}
function _loadSessionWrapper() {
  _loadSessionWrapper = _asyncToGenerator(function* (dh, connection, sessionDetails) {
    var sessionWrapper;
    try {
      sessionWrapper = yield createSessionWrapper(dh, connection, sessionDetails);
    } catch (e) {
      // Consoles may be disabled on the server, but we should still be able to start up and open existing objects
      if (!isNoConsolesError(e)) {
        throw e;
      }
    }
    return sessionWrapper;
  });
  return _loadSessionWrapper.apply(this, arguments);
}
//# sourceMappingURL=SessionUtils.js.map